export default __webpack_public_path__ + "static/media/nutanixLogo.1f815521.svg";